
import CustomDropzoneWrapper from '~/components/elements/CustomDropzone/Wrapper';
import CustomDropzoneInput from '~/components/elements/CustomDropzone/Input';
import CustomDropzonePreview from '~/components/elements/CustomDropzone/Preview';

import { addFiles, removeFile } from '~/components/elements/CustomDropzone/helpers';

export default {
  name: 'CustomDropzone',
  components: {CustomDropzonePreview, CustomDropzoneWrapper, CustomDropzoneInput },
  props: {
    options: {
      type: Object,
      required: true,
    },
    fileList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dropzone: {},
      defaultOptions: {
        accept: '',
        fileSize: 0, // Kb
        defaultText: true,
        fileNum: 0,
      },
      isValid: true,
      validTimeout: null,
      fileErrors: [],
    }
  },
  created() {
    Object.assign(this.dropzone, this.defaultOptions, this.options)
  },
  beforeDestroy() {
    clearTimeout(this.validTimeout)
  },
  methods: {
    addFiles,
    removeFile,
    addFilesHandler(files) {
      const { valid, errors } = this.addFiles(this.fileList, files, this.dropzone)

      this.isValid = valid
      this.fileErrors = errors

      clearTimeout(this.validTimeout)

      if (!this.isValid) {
        this.validTimeout = setTimeout(() => {
          this.isValid = true
        }, 3000)
      }
    },
    removeFileHandler(file) {
      this.removeFile(this.fileList, file)
    },
    activeHandler(state) {
      this.$emit('active', state)
    },
  },
}
